import { createSlice } from "@reduxjs/toolkit";

import { DEFAUT_VALUEE_FILTERS } from "../../../../../pages/MainPage/pages/Archives/tabs/BankTransactions/components/Header/components/FiltersModal";
import { DateFns } from "../../../../../utils/DateFns";
import { Archive, ReduxReducer } from "../../interface";

import { State } from "./interface";

const baseDateFns = new DateFns();

const initialState: State = {
	dateRange: {
		from: baseDateFns.startDate(),
		to: baseDateFns.endDate(),
	},
	byMultyFilters: DEFAUT_VALUEE_FILTERS,
};

const setDateFrom: ReduxReducer<State, Date> = (state, { payload }) => {
	state.dateRange.from = payload;
};

const setDateTo: ReduxReducer<State, Date> = (state, { payload }) => {
	state.dateRange.to = payload;
};

const resetFilter: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const setFiltersByMultyFilters: ReduxReducer<State, State["byMultyFilters"]> = (
	state,
	{ payload },
) => {
	state.byMultyFilters = payload;
};

const archivesBankTransactionsFilters = createSlice({
	name: Archive.ConstantOrderSlice.BANK_TRANSACTIONS_FILTER,
	initialState,
	reducers: {
		resetFilter,
		setDateFrom,
		setDateTo,
		setFiltersByMultyFilters,
	},
});

export const archivesBankTransactionsFilterAction =
	archivesBankTransactionsFilters.actions;
export const archivesBankTransactionsFilterReducer =
	archivesBankTransactionsFilters.reducer;
export type archivesBankTransactionsFilterState = State;

export default archivesBankTransactionsFilters;
